module.exports = __webpack_public_path__ + "static/img/Darcy-Moore.f1b3fb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Darcy-Moore.jpg
// module id = +iUT
// module chunks = 0